
import './App.css';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { PageProvider } from './context/PageContect';

// import SelectChurch from './Pages/SelectChurch/SelectChurch';
import MainWindow from './Pages/MainWindow/MainWindow';

function App() {
  const queryParameters = new URLSearchParams(window.location.search)
  const churchid = queryParameters.get("churchid")
  return (
    <PageProvider>
      <MainWindow churchid={churchid}/>
    </PageProvider>
  );
}

export default App;
